<template>
  <div>
    <v-main>
      <div class="pa-4">
        <v-row>
          <v-col>
            <h2>รายงานการให้คะแนน</h2>
          </v-col>
          <v-col class="text-right">
            <v-btn class="ma-2" outlined color="indigo" @click="exportExcel()">
              <v-icon left>mdi-download</v-icon>
              Export Data
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="col-grid">
          <div>
            <v-select
              v-model="selectExchange"
              :items="dataExchange"
              :label="session.data.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350' ? 'ประเภทสินค้า' : 'บริการ'"
              dense
              outlined
              hide-details
            ></v-select>
          </div>
          <div>
            <v-select
              v-model="selectBranch"
              :items="dataBranch"
              label="สาขา"
              dense
              outlined
              hide-details
            ></v-select>
          </div>
          <div>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  label="ค้นหาตามวันที่"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="clearTextField()"
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title scrollable range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div>
            <v-text-field
              v-model="search"
              label="ค้นหา ชื่อ / เบอร์โทร / ชื่อไลน์"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              hide-details
            ></v-text-field>
          </div>
          <div class="text-center btn-grid d-flex justify-center">
            <v-btn color="success" class="me-1" dark @click.stop="sortData()">ค้นหา</v-btn>
            <v-btn color="error" class="me-1" dark @click.stop="getDataAll(), resetData()"
              >ยกเลิก</v-btn
            >
          </div>
        </v-row>
        <v-row>
          <v-col>
            <template>
              <v-data-table
                v-if="this.session.data.shopId === 'SD_1715763703870'"
                :headers="headers_sun"
                :items="desserts"
                :items-per-page="10"
                :search="search"
                :custom-filter="customSearch"
              >
                <template v-slot:[`item.img_slip`]="{ item }">
                  <v-btn
                    v-if="item.img_slip"
                    dark
                    color="#757575"
                    @click="openImg(item)"
                    >ดูรูป</v-btn
                  >
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  {{ formatNumber(item.amount) }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <!-- <p></p> -->
                  <p :style="{ color: getColor(item.status) }">
                    {{ item.status }}
                  </p>
                </template>
              </v-data-table>
              <v-data-table
                v-else
                :headers="
                  session.data.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350'
                    ? headersBpv : session.data.shopId !== shopNameData.SHOP_ID_CHUBB ? headers : headersLMG
                "
                :items="desserts"
                :items-per-page="10"
                :search="search"
                :custom-filter="customSearch"
              >
                <template v-slot:[`item.img_slip`]="{ item }">
                  <v-btn
                    v-if="item.img_slip"
                    dark
                    color="#757575"
                    @click="openImg(item)"
                    >ดูรูป</v-btn
                  >
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  {{ formatNumber(item.amount) }}
                </template>
                <template v-slot:[`item.CREATE_DATES`]="{ item }">
                  {{ thaiFormattedDate(item.CREATE_DATES) }}
                </template>
                <template v-slot:[`item.LAST_DATE`]="{ item }">
                  {{ thaiFormattedDate(item.LAST_DATE) }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <!-- <p></p> -->
                  <p :style="{ color: getColor(item.status) }">
                    {{ item.status }}
                  </p>
                </template>
                <template
                  v-if="
                    session.data.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350'
                  "
                  v-slot:[`item.detial`]="{ item }"
                >
                  <v-btn
                    class="ma-2"
                    outlined
                    color="indigo"
                    @click="showDetial(item.DOCNO)"
                    v-if="item.DOCNO"
                  >
                    <v-icon center> mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </template>
          </v-col>
        </v-row>
        <v-dialog v-model="dialog" width="400" style="">
          <v-card>
            <v-container>
              <div class="text-right">
                <v-btn class="mx-2" fab dark small color="grey lighten-1">
                  <v-icon dark @click="dialog = false"> mdi-close </v-icon>
                </v-btn>
              </div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-top: 10px;
                "
              >
                <image-zoom
                  :regular="imgOpen"
                  :zoom="imgOpen"
                  :zoom-amount="2.5"
                  img-class="img-fluid"
                  alt="Sky"
                  @on-zoom="zoom = true"
                  @off-zoom="zoom = false"
                >
                </image-zoom>
              </div>
            </v-container>
            <v-card-actions> </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogDetial"
          v-if="dataDetial.length != 0"
          width="400"
          style=""
        >
          <v-card>
            <v-container>
              <div>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  {{ dataDetial[0].DOCNO }}
                  <v-btn class="mx-2" fab dark small color="grey lighten-1">
                    <v-icon dark @click="dialogDetial = false; dataDetial = []">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </div>
              </div>

              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-top: 10px;
                "
              >
                <v-data-table
                  :headers="headerDetials"
                  :items="dataDetial"
                  :items-per-page="10"
                ></v-data-table>
                <!-- <v-row v-for="i in dataDetial">
              </v-row> -->
                <!-- {{ dataDetial }} -->
              </div>
            </v-container>
            <v-card-actions> </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import readXlsxFile from 'read-excel-file'
import XLSX from 'xlsx' // import xlsx
import imageZoom from 'vue-image-zoomer'
// import constants from '@/constants.js'

export default {
  components: {
    moment,
    downloadExcel: JsonExcel,
    readXlsxFile,
    XLSX,
    imageZoom
  },
  data () {
    return {
      dataDetial: [],
      dialog: false,
      dialogDetial: false,
      imgOpen: null,
      headerDetials: [
        { text: 'ITEMCODE', value: 'ITEMCODE' },
        { text: 'ราคา', value: 'F_UNITPRICE' },
        { text: 'คะแนน', value: 'POINT' }
      ],
      headers: [
        { text: 'บริการ', value: 'productExchangeRateName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'slip', value: 'img_slip' },
        { text: 'คะแนน', value: 'point' },
        { text: 'รายได้', value: 'amount' },
        { text: 'หมายเหตุ', value: 'refId' },
        // { text: 'ผู้รับผิดชอบ', value: 'displayName' },
        { text: 'ผู้รับผิดชอบ', value: 'displayName' },
        { text: 'ผู้รับคะแนน', value: 'nameCustomer' },
        { text: 'ชื่อไลน์ผู้รับ', value: 'name' },
        { text: 'เบอร์โทร', value: 'tel' },
        { text: 'วันเกิด', value: 'birthDay' },
        { text: 'เพศ', value: 'gender' },
        { text: 'สถานะ', value: 'status' },
        { text: 'ระบบให้บริการ', value: 'typeAddPoint' },
        { text: 'เลขที่ใบเสร็จ', value: 'No_recript' },
        { text: 'วันที่ลูกค้าอัปโหลดสลิป', value: 'DATE_UPLOAD' },
        { text: 'วันที่ร้านค้าแจกคะแนน', value: 'DATE_ADMIN_UPDATE' }
      ],
      headersLMG: [
        { text: 'บริการ', value: 'productExchangeRateName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'slip', value: 'img_slip' },
        { text: 'คะแนน', value: 'point' },
        { text: 'รายได้', value: 'amount' },
        { text: 'หมายเหตุ', value: 'refId' },
        // { text: 'ผู้รับผิดชอบ', value: 'displayName' },
        { text: 'ผู้รับผิดชอบ', value: 'displayName' },
        { text: 'ผู้รับคะแนน', value: 'nameCustomer' },
        { text: 'ชื่อไลน์ผู้รับ', value: 'name' },
        { text: 'รหัสพนักงาน', value: 'tel' },
        { text: 'วันเกิด', value: 'birthDay' },
        { text: 'เพศ', value: 'gender' },
        { text: 'สถานะ', value: 'status' },
        { text: 'ระบบให้บริการ', value: 'typeAddPoint' },
        { text: 'เลขที่ใบเสร็จ', value: 'No_recript' },
        { text: 'วันที่ลูกค้าอัปโหลดสลิป', value: 'DATE_UPLOAD' },
        { text: 'วันที่ร้านค้าแจกคะแนน', value: 'DATE_ADMIN_UPDATE' }
      ],
      headersBpv: [
        // { text: 'บริการ', value: 'ItemGroup' },
        { text: 'สาขา', value: 'BRANCHNAME' },
        { text: 'คะแนน', value: 'point' },
        { text: 'รายได้', value: 'amount' },
        // { text: 'ผู้รับผิดชอบ', value: 'displayName' },
        { text: 'ผู้รับคะแนน', value: 'nameCustomer' },
        { text: 'ชื่อไลน์ผู้รับ', value: 'name' },
        { text: 'เบอร์โทร', value: 'tel' },
        { text: 'วันเกิด', value: 'birthDay' },
        { text: 'เพศ', value: 'gender' },
        { text: 'สถานะ', value: 'status' },
        // { text: 'ระบบให้บริการ', value: 'typeAddPoint' },
        { text: 'เลขที่ใบเสร็จ', value: 'DOCNO' },
        // { text: 'วันที่ลูกค้าอัปโหลดสลิป', value: 'DATE_UPLOAD' },
        { text: 'วันที่ร้านค้าแจกคะแนน', value: 'LAST_DATE' },
        { text: 'รายละเอียด', value: 'detial' }
      ],
      headers_sun: [
        { text: 'บริการ', value: 'productExchangeRateName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'slip', value: 'img_slip' },
        { text: 'คะแนน', value: 'point' },
        { text: 'รายได้', value: 'amount' },
        { text: 'หมายเหตุ', value: 'refId' },
        // { text: 'ผู้รับผิดชอบ', value: 'displayName' },
        { text: 'ผู้รับผิดชอบ', value: 'SYS_USER_displayName' },
        { text: 'ผู้รับคะแนน', value: 'nameCustomer' },
        { text: 'ชื่อไลน์ผู้รับ', value: 'name' },
        { text: 'เบอร์โทร', value: 'tel' },
        { text: 'วันเกิด', value: 'birthDay' },
        { text: 'เพศ', value: 'gender' },
        { text: 'สถานะ', value: 'status' },
        { text: 'ระบบให้บริการ', value: 'typeAddPoint' },
        { text: 'เลขที่ใบเสร็จ', value: 'No_recript' },
        { text: 'วันที่ลูกค้าอัปโหลดสลิป', value: 'DATE_UPLOAD' },
        { text: 'วันที่ร้านค้าแจกคะแนน', value: 'DATE_ADMIN_UPDATE' }
      ],
      desserts: [],
      dataBranch: [],
      dataExchange: [],
      selectExchange: '',
      dataExportBPV: [],
      branchName: '',
      menu: false,
      session: this.$session.getAll(),
      menu2: false,
      idPackage: '',
      nameSearch: '',
      search: '',
      date: [],
      selectBranch: '',
      export_data: null,
      exportType: 'xls',
      exportWorksheet: 'WorkSheet',
      exportFileName: 'Report_Point',
      objtimeBpv: {},
      export_field: {
        บริการ: 'productExchangeRateName',
        คะแนน: 'point',
        รายได้: 'amount',
        หมายเหตุ: 'refId',
        ผู้รับผิดชอบ: 'displayName',
        ผู้รับคะแนน: 'nameCustomer',
        เบอร์โทร: 'tel',
        วันเกิด: 'birthDay',
        เพศ: 'gender',
        สถานะ: 'status',
        วันที่ลูกค้าอัปโหลดสลิป: 'DATE_UPLOAD',
        วันที่ร้านค้าแจกคะแนน: 'DATE_ADMIN_UPDATE'
      },
      export_field_LMG: {
        บริการ: 'productExchangeRateName',
        คะแนน: 'point',
        รายได้: 'amount',
        หมายเหตุ: 'refId',
        ผู้รับผิดชอบ: 'displayName',
        ผู้รับคะแนน: 'nameCustomer',
        รหัสพนักงาน: 'tel',
        วันเกิด: 'birthDay',
        เพศ: 'gender',
        สถานะ: 'status',
        วันที่ลูกค้าอัปโหลดสลิป: 'DATE_UPLOAD',
        วันที่ร้านค้าแจกคะแนน: 'DATE_ADMIN_UPDATE'
      }
    }
  },
  computed: {
    dateRangeText () {
      return this.date.join(' - ')
    }
  },

  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.getDataAll()
    this.getBranch()
    this.getExchane()
    this.generateFileName()
  },
  methods: {
    generateFileName () {
      const date = moment().format('DDMMYYYY')
      this.exportFileName = `Report_Point_${date}.xls`
    },
    async showDetial (e) {
      // dataDetial
      this.dataDetial = []
      try {
        const resp = await axios.get(this.DNS_IP + '/hitorysell/get?DOCNO=' + e)
        if (resp.data.length) {
          for await (const i of resp.data) {
            this.dataDetial.push(i)
          }
          this.dialogDetial = true
        } else {
          this.dataDetial = []
          this.dialogDetial = false
        }
      } catch (err) {
        this.dataDetial = []
        this.dialogDetial = false
      }
      // console.log('resp ', resp)
    },
    async getDataAll () {
      let sql = ''
      if (this.session.data.shopId !== 'U4e23f7bf31b362622ff7c5c06dfdf350') {
        if (this.session.data.userTypeGroup === 'cashier') {
          sql =
            this.DNS_IP +
            '/qrcode/get?shopId=' +
            this.session.data.shopId +
            '&statusin="used","reject"' +
            '&userId=' +
            this.session.data.userId
        } else {
          sql =
            this.DNS_IP +
            '/qrcode/get?shopId=' +
            this.session.data.shopId +
            '&statusin="used","reject"'
        }
      } else {
        if (this.session.data.userTypeGroup === 'cashier') {
          sql =
            this.DNS_IP +
            '/qrcodeBpv/back/get?shopId=' +
            this.session.data.shopId +
            '&statusin="used","reject"' +
            '&userId=' +
            this.session.data.userId
        } else {
          sql =
            this.DNS_IP +
            '/qrcodeBpv/back/get?shopId=' +
            this.session.data.shopId +
            '&statusin="used","reject"'
        }
      }
      console.log('sql >>>', sql)
      const ress = await axios.get(sql)
      if (ress.data.length) {
        console.log('ress.data', ress.data)
        this.processData(ress.data)
      } else {
        this.desserts = []
      }
      // axios.get(sql).then((res) => {
      //   if (res.data.statusv === false) {
      //     this.desserts = []
      //   } else {
      //     console.log('data=======>>', res.data)
      //     this.processData(res.data)
      //   }
      // })
    },
    getColor (status) {
      if (status === 'ไม่สำเร็จ') return 'red'
      else if (status === 'สำเร็จ') return 'green'
    },
    sortData () {
      let queryParams = []

      // Check if each parameter has a value and add it to queryParams array
      if (this.session.data.shopId) {
        queryParams.push(
          `shopId=${encodeURIComponent(this.session.data.shopId)}`
        )
      }
      if (this.selectBranch) {
        const paramName =
          this.session.data.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350'
            ? 'BRANCHCODE'
            : 'masBranchID'
        queryParams.push(
          `${paramName}=${encodeURIComponent(this.selectBranch)}`
        )
      }
      if (this.selectExchange) {
        const paramName =
          this.session.data.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350'
            ? 'ItemGroup'
            : 'exchang'
        queryParams.push(
          `${paramName}=${encodeURIComponent(this.selectExchange)}`
        )
      }
      if (this.session.data.userTypeGroup === 'cashier') {
        queryParams.push(
          `userId=${encodeURIComponent(this.session.data.userId)}`
        )
      }
      console.log('this.date.length', this.date.length)
      let startDate = ''
      let endDate = ''
      if (this.date.length === 2) {
        this.date.sort()
        startDate = moment(this.date[0]).format('YYYY-MM-DD')
        endDate = moment(this.date[1]).format('YYYY-MM-DD')
        queryParams.push(
          `LAST_DATE=${encodeURIComponent(`${startDate},${endDate}`)}`
        )
      } else if (this.date.length === 1) {
        startDate = moment(this.date[0]).format('YYYY-MM-DD')
        console.log('this.date.length', startDate)
        endDate = moment(this.date[0]).format('YYYY-MM-DD')
        queryParams.push(
          `LAST_DATE=${encodeURIComponent(`${startDate},${endDate}`)}`
        )
      }

      // statusin is a static value in this case, always add it
      queryParams.push(`statusin="used","reject"`)

      // Join the parameters with '&'
      let queryString = queryParams.join('&')

      // Construct the final URL
      const urlName =
        this.session.data.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350'
          ? '/qrcodeBpv/back/get'
          : '/qrcode/get'
      let url = `${this.DNS_IP}${urlName}?${queryString}`
      console.log(queryString)
      axios.get(url).then((res) => {
        if (res.data.status === false) {
          this.desserts = []
        } else {
          this.processData(res.data)
        }
      })
    },
    processData (data) {
      this.desserts = data
      console.log('this.desserts33333', data)
      this.desserts.map((el) => {
        if (el.status === 'reject') {
          el.status = 'ไม่สำเร็จ'
        } else if (el.status === 'used') {
          el.status = 'สำเร็จ'
        }
        if (el.SYS_USER_displayName === null) {
          el.SYS_USER_displayName = el.displayName
        }
      })
      this.export_data = data
      this.export_data.map((el) => {
        el.DATE_ADMIN_UPDATE = this.thaiFormattedLAST_Date(
          el.DATE_ADMIN_UPDATE
        )
        if (
          el.birthDay &&
          el.birthDay !== '' &&
          el.birthDay !== 'Invalid date' &&
          el.birthDay !== null
        ) {
          el.birthDay = moment(el.birthDay)
            .add(543, 'years')
            .format('DD/MM/YYYY')
        } else {
          el.birthDay = ''
        }
        if (el.displayName === 'None') {
          el.displayName = ''
        }
        delete el['CONDITION_TERM1']
        delete el['CONDITION_TERM2']
        delete el['id']
        delete el['productExchangeRateId']
        delete el['shopId']
        delete el['token']
        delete el['RECORD_STATUS']
        delete el['CREATE_DATE']
        delete el['CREATE_USER']
        delete el['LAST_USER']
        delete el['qrCodeURL']
        delete el['statusMemberCard']
        delete el['statusLot']
        delete el['lotId']
        delete el['friendGetfriend']
        delete el['liffUserId']
        delete el['lineUserId']
        delete el['masBranchID']
        delete el['LAST_DATE_TH']
        delete el['branchName']
        delete el['expriSubCoin']
      })
    },
    resetData () {
      this.selectExchange = ''
      this.selectBranch = ''
      this.date = []
      this.getDataAll()
    },
    clearTextField () {
      this.date = []
      this.getDataAll()
    },
    getBranch () {
      this.dataBranch = []
      if (this.session.data.shopId !== 'U4e23f7bf31b362622ff7c5c06dfdf350') {
        axios
          .get(
            this.DNS_IP +
              '/master_branch/get?shopId=' +
              this.session.data.shopId
          )
          .then((res) => {
            let rs = res.data
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.value = d.masBranchID
              s.text = d.masBranchName
              d = s
              this.dataBranch.push(d)
            }
            this.dataBranch.push({
              text: 'ทั้งหมด',
              value: '',
              levelId: ''
            })
          })
      } else {
        axios
          .post(this.DNS_IP + '/hitorysell/get-wherehouse', {})
          .then((res) => {
            let rs = res.data
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.value = d.BRANCHCODE
              s.text = d.BRANCHCODE
              d = s
              this.dataBranch.push(d)
            }
            this.dataBranch.push({
              text: 'ทั้งหมด',
              value: '',
              levelId: ''
            })
          })
        console.log('this.dataBranch', this.dataBranch)
      }
    },
    getExchane () {
      this.dataExchange = []
      if (this.session.data.shopId !== 'U4e23f7bf31b362622ff7c5c06dfdf350') {
        axios
          .get(
            this.DNS_IP +
              '/productExchangeRate/get?shopId=' +
              this.session.data.shopId
          )
          .then((res) => {
            let rs = res.data
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.value = d.productExchangeRateId
              s.text = d.name
              d = s
              this.dataExchange.push(d)
            }
            this.dataExchange.push({
              text: 'ทั้งหมด',
              value: '',
              levelId: ''
            })
          })
      } else {
        axios
          .post(this.DNS_IP + '/hitorysell/get-itemgroup', {})
          .then((res) => {
            let rs = res.data
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.value = d.ItemGroup
              s.text = d.ItemGroup
              d = s
              this.dataExchange.push(d)
            }
            this.dataExchange.push({
              text: 'ทั้งหมด',
              value: '',
              levelId: ''
            })
          })
      }
    },
    async exportExcel () {
      var data = []
      var dataFinal = {}
      let pushDataFinal = []

      if (this.session.data.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350') {
        console.log(this.desserts)
        let docno = await Promise.all(
          this.desserts.map(async (el) => {
            if (el.DOCNO) {
              // ตัวอย่าง async operation
              this.objtimeBpv[el.DOCNO] = el.LAST_DATE
              return el.DOCNO
            }
            return null
          })
        )
        // กรอง null ออก
        docno = docno.filter(Boolean)
        console.log('docno', this.objtimeBpv)
        try {
          if (docno.length > 0) {
            const res = await axios.post(this.DNS_IP + '/hitorytSell/get-report', docno)
            this.dataExportBPV = res.data
            console.log(this.dataExportBPV)
          } else {
            alert('ไม่มีข้อมูลใบเสร็จ')
            return
          }
        } catch (error) {
          console.error('Error fetching report:', error)
        }
      } else {
        this.desserts.map((el) => {
          data.push(el)
        })
      }
      if (this.session.data.shopId === this.shopNameData.SHOP_ID_CHUBB) {
        data.map((resule) => {
          dataFinal = {
            บริการ: resule.productExchangeRateName,
            คะแนน: resule.point,
            รายได้: resule.amount,
            หมายเหตุ: resule.refId,
            ผู้รับผิดชอบ: resule.displayName,
            ผู้รับคะแนน: resule.nameCustomer,
            รหัสพนักงาน: resule.tel,
            วันเกิด: resule.birthDay,
            เพศ: resule.gender,
            สถานะ: resule.status,
            วันที่ลูกค้าอัปโหลดสลิป: resule.DATE_UPLOAD,
            วันที่ร้านค้าแจกคะแนน: resule.DATE_ADMIN_UPDATE,
            สลิป: resule.img_slip
          }
          pushDataFinal.push(dataFinal)
        })
      } else if (this.session.data.shopId !== 'U4e23f7bf31b362622ff7c5c06dfdf350') {
        data.map((resule) => {
          dataFinal = {
            บริการ: resule.productExchangeRateName,
            คะแนน: resule.point,
            รายได้: resule.amount,
            หมายเหตุ: resule.refId,
            ผู้รับผิดชอบ: resule.displayName,
            ผู้รับคะแนน: resule.nameCustomer,
            เบอร์โทร: resule.tel,
            วันเกิด: resule.birthDay,
            เพศ: resule.gender,
            สถานะ: resule.status,
            วันที่ลูกค้าอัปโหลดสลิป: resule.DATE_UPLOAD,
            วันที่ร้านค้าแจกคะแนน: resule.DATE_ADMIN_UPDATE,
            สลิป: resule.img_slip
          }
          pushDataFinal.push(dataFinal)
        })
      } else {
        this.dataExportBPV.map((resule) => {
          dataFinal = {
            'เลขที่ใบเสร็จ': resule.DOCNO,
            'ITEMCODE': resule.ITEMCODE,
            'lineUserId': resule.lineUserId,
            'ผู้รับคะแนน': resule.nameCustomer,
            'เบอร์โทรศัพท์': resule.MemberTel.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'),
            'คะแนน': resule.POINT,
            'วันที่ได้คะแนน': this.thaiFormattedDateHHmm(this.objtimeBpv[resule.DOCNO])
            // คะแนน: resule.point,
            // รายได้: resule.amount,
            // หมายเหตุ: resule.refId,
            // ผู้รับผิดชอบ: resule.displayName,
            // ผู้รับคะแนน: resule.nameCustomer,
            // เบอร์โทร: resule.tel,
            // วันเกิด: resule.birthDay,
            // เพศ: resule.gender,
            // สถานะ: resule.status,
            // วันที่ลูกค้าอัปโหลดสลิป: resule.DATE_UPLOAD,
            // วันที่ร้านค้าแจกคะแนน: resule.DATE_ADMIN_UPDATE,
            // สลิป: resule.img_slip
          }
          pushDataFinal.push(dataFinal)
        })
        // await Promise.all(
        //   this.desserts.map(async (el) => {
        //     if (el.DOCNO) {
        //       // ตัวอย่าง async operation
        //       return el.DOCNO;
        //     }
        //     return null;
        //   })
        // )
      }

      const dataWS = XLSX.utils.json_to_sheet(pushDataFinal)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      const dNow = new Date()
      XLSX.writeFile(wb, 'Report_Point_' + moment(dNow).format('YYYYMMDD') + '.xlsx')
    },
    openImg (item) {
      this.dialog = true
      this.imgOpen = item.img_slip
    },
    clearSearch () {
      this.date = ''
      this.nameSearch = ''
    },
    customSearch (value, search, item) {
      if (!search) return true
      const q = String(search).toLowerCase().trim()
      if (!q) return true
      return [item.nameCustomer, item.tel, item.displayName, item.name]
        .some(v => v != null && String(v).toLowerCase().includes(q))
    }
  }
}
</script>
<style scoped>
h3 {
  font-size: 18.72px !important;
}

.col-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }

  .btn-grid {
    grid-column: -1;
    justify-self: stretch;
  }

  @media screen and (max-width: 768px) {
    .btn-grid {
      grid-column: auto;
      justify-self: center;
      justify-self: stretch;
    }
    .col-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 16px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/Reports/reportAddPoint.vue